<template>
    <div class="cotinent-desc">
        <div class="desc">
            <div class="stat-wrapper">
                <div class="custom-stat">
                    <div class="progress-stat">
                        <svg class="circle-chart" :class="this.stats.class" viewbox="0 0 150 150" width="150" height="150" xmlns="http://www.w3.org/2000/svg">
                            <circle class="circle-chart__background" stroke="#899095" stroke-width="12" fill="none" cx="75" cy="75" r="70" />
                            <circle class="circle-chart__circle" style=" transform: rotate(-90deg); transform-origin: center; " stroke="#00a773" stroke-width="20" stroke-dasharray="0,435"  fill="none" cx="75" cy="75" r="70" />
                        </svg>
                        <div class="progress-value">
                            <span class="counter" :data-number="this.stats.revenue"></span>
                            <span>%</span>
                        </div>
                    </div>
                    <div class="progress-name ">{{$t("labels.totalRevenue")}}<br>{{$t("labels.contribution2")}}</div>
                </div>
                <div class="custom-stat">
                    <div class="progress-stat">
                        <svg class="circle-chart ninty" :class="this.stats.class2"  viewbox="0 0 150 150" width="150" height="150" xmlns="http://www.w3.org/2000/svg">
                            <circle class="circle-chart__background" stroke="#899095" stroke-width="12" fill="none" cx="75" cy="75" r="70" />
                            <circle class="circle-chart__circle" style=" transform: rotate(-90deg); transform-origin: center; " stroke="#00a773" stroke-width="20" stroke-dasharray="0,435" fill="none" cx="75" cy="75" r="70" />
                        </svg>
                        <div class="progress-value">
                            <span class="counter" :data-number="this.stats.customers"></span>
                            <span>%</span>
                        </div>
                    </div>
                    <div class="progress-name">{{$t("labels.totalCustomers")}}<br>{{$t("labels.contribution")}}</div>
                </div>
            </div>
        </div>
        <div class="map">
            <div class="image">
                <img :src="require(`@/assets/images/svg/${mapImage}`)" alt="World Of Zain" class="img-fluid">
            </div>
        </div>
    </div>
</template>

<script>
import animation from '@/mixin/animation'
    export default {
        props:{
            stats: Object,
            mapImage: String
        },
        mixins:[animation],
        mounted(){
            this.counterAnimation();
        }
    }
</script>
<style lang="scss" scoped>
.stat-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    >.custom-stat {
        &:first-child {
            margin-right: rem(80px);
            @media screen and (max-width: 575px) {
                margin-right: rem(30px);
            }
        }
    }
    /deep/{
        @media only screen and (min-device-width: 768px) and (max-device-width: 991px){
            .custom-stat .circle-chart__circle{
                cx: 61;
                cy: 90;
            }
        }
    }
}
.custom-stat {
    text-align: center;
    .progress-stat {
        position: relative;
        svg {
            max-width: 100%;
            overflow: visible;
        }
        .progress-value {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ffffff;
            font-size: rem(32px);
            font-weight: 900;
            display: inline-flex;
            align-items: center;
        }
    }
    .circle-chart {
        &__circle {
            animation: progress 2s linear forwards;
        }
        &.ninty {
            .circle-chart__circle {
                animation: progress90 2s linear forwards;
            }
        }
        &.nine {
            .circle-chart__circle {
                animation: progress9 2s linear forwards;
            }
        }
        &.thirtySeven {
            .circle-chart__circle {
                animation: progress37 2s linear forwards;
            }
        }
        
    }
    .progress-name {
        margin-top: rem(20px);
        font-weight: 600;
        color: white;
        text-transform: uppercase;
        line-height: 1.2;
    }
    
}
.cotinent-desc {
    @include flex(center, center);
    flex-wrap: nowrap;
    position: relative;
    margin-top: rem(100px);
    &:after {
        width: 2px;
        height: 110%;
        content: '';
        background-color: #8d9599;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        top: 50%;
        transform: translateY(-50%);
        @media screen and (max-width: 1600px) {
            height: 100%;
        }
        @media screen and (max-width:991px) {
            right: -20px;
        }
    }
    .desc {
        .image {
            max-width: 415px;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
        }
        position: relative;
        flex: 0 0 50%;
        padding-right: rem(45px);
        // margin-right: rem(45px);
    }
    .map {
        flex: 0 0 50%;
        padding-left: rem(120px);
        // margin-left: rem(45px);
        .image {
            max-width: 550px;
            width: 100%;
        }
    }
    
    @media screen and (max-width:1199px) {
        .map {
            padding-left: rem(50px);
        }
    }
     @media screen and (max-width:991px) {
        .map {
            .image {
                max-width:320px;
                margin:auto;
            }
        }
    }
    @media screen and (max-width:767px) {
        flex-direction: column-reverse;
        align-items: unset;
        padding-top: rem(120px);
        padding-bottom: rem(50px);
        &:after {
            width: 90%;
            height: 2px;
            top: 60%;
        }
        .desc {
            padding: rem(60px) 0 0 0 !important;
            .image {
                max-width: 300px;
            }
        }
        .map {
            flex: 0 0 100%;
            padding: 0 !important;
            .image {

                margin-bottom:rem(20px);
            }
        }
    }
}
[lang="ar"]{
    .stat-wrapper {
    >.custom-stat {
        &:first-child {
            margin-left: rem(80px);
            margin-right:0;
            @media screen and (max-width: 575px) {
                margin-left: rem(30px);
                margin-right:0;
            }
        }
    }
}
.cotinent-desc {
    &:after {
        @media screen and (max-width:991px) {
            left: -20px;
            right:0;
        }
    }
    .desc {
        padding-left: rem(45px);
        padding-right:0;
    }
    .map {
        padding-right: rem(120px);
        padding-left:0;
    }
    @media screen and (max-width:1199px) {
        .map {
            padding-right: rem(50px);
            padding-left:0;
        }
    }
}
}
@keyframes progress {
    0% {
        stroke-dasharray: 0px, 435px;
    }
    100% {
        stroke-dasharray: 395px, 435px;
    }
}

@keyframes progress90 {
    0% {
        stroke-dasharray: 0px, 435px;
    }
    100% {
        stroke-dasharray: 274px, 435px;
    }
}

@keyframes progress9 {
    0% {
        stroke-dasharray: 0px, 435px;
    }
    100% {
        stroke-dasharray: 39px, 435px;
    }
}

@keyframes progress37 {
    0% {
        stroke-dasharray: 0px, 435px;
    }
    100% {
        stroke-dasharray: 162px, 435px;
    }
}
</style>